import * as React from 'react';
import { css } from 'aphrodite';

import styles from './onboardingFormIconStyles';

export default class HouseSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.positioning)}
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
      >
        <title>icon_house</title>
        <defs />
        <g
          id="icon_house"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="home" transform="translate(3.000000, 2.000000)" stroke="#757575" strokeWidth="1.6">
            <path
              d="M0,5.6 L7,0 L14,5.6 L14,14.4 C14,15.2836556 13.3035541,16 12.4444444,16 L1.55555556,16 C0.696445945,16 0,15.2836556 0,14.4 L0,5.6 Z"
              id="Shape"
            />
            <polyline id="Shape" points="4.5 16 4.5 10 9.5 10 9.5 16" />
          </g>
        </g>
      </svg>
    );
  }
}
